import React, {
  createContext,
  useContext,
  useState,
} from 'react';
import {
  MVPFormData,
  FormInitialValue,
  DropDownType,
} from '../../pages/advanta-mvp-charts/constants';

interface FilterContextType {
  filterValues: MVPFormData;
  setFilterValues: (values: MVPFormData) => void;
  regionManagerList: DropDownType[];
  tpmList: DropDownType[];
  faList: DropDownType[];
  rmListffc: DropDownType[];
  tpmListffc: DropDownType[];
  plListffc: DropDownType[];
  scmListffc: DropDownType[];
  hybridTypeList: DropDownType[];
  weeksOfSowing: DropDownType[];
  setRegionManagerList: (list: DropDownType[]) => void;
  setTpmList: (list: DropDownType[]) => void;
  setFaList: (list: DropDownType[]) => void;
  setRegionManagerListFfc: (list: DropDownType[]) => void;
  setTpmListFfc: (list: DropDownType[]) => void;
  setPlListFfc: (list: DropDownType[]) => void;
  setScmListFfc: (list: DropDownType[]) => void;
  setHybridTypeList: (list: DropDownType[]) => void;
  setWeeksOfSowing: (list: DropDownType[]) => void;
}

const FilterContext = createContext<
  FilterContextType | undefined
>(undefined);

export const FilterProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [filterValues, setFilterValues] =
    useState<MVPFormData>(FormInitialValue);
  const [regionManagerList, setRegionManagerList] =
    useState<DropDownType[]>([]);
  const [tpmList, setTpmList] = useState<DropDownType[]>(
    []
  );
  const [faList, setFaList] = useState<DropDownType[]>([]);
  const [rmListffc, setRegionManagerListFfc] = useState<
    DropDownType[]
  >([]);
  const [tpmListffc, setTpmListFfc] = useState<
    DropDownType[]
  >([]);
  const [plListffc, setPlListFfc] = useState<
    DropDownType[]
  >([]);
  const [scmListffc, setScmListFfc] = useState<
    DropDownType[]
  >([]);
  const [hybridTypeList, setHybridTypeList] = useState<
    DropDownType[]
  >([]);
  const [weeksOfSowing, setWeeksOfSowing] = useState<
    DropDownType[]
  >([]);

  return (
    <FilterContext.Provider
      value={{
        filterValues,
        setFilterValues,
        regionManagerList,
        tpmList,
        faList,
        rmListffc,
        tpmListffc,
        plListffc,
        scmListffc,
        hybridTypeList,
        weeksOfSowing,
        setRegionManagerList,
        setTpmList,
        setFaList,
        setRegionManagerListFfc,
        setTpmListFfc,
        setPlListFfc,
        setScmListFfc,
        setHybridTypeList,
        setWeeksOfSowing,
      }}>
      {children}
    </FilterContext.Provider>
  );
};

export const useFilterContext = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error(
      'useFilterContext must be used within a FilterProvider'
    );
  }
  return context;
};
